<div class="action-dropdown">
  <div class="log-actions" *ngIf="open=='logActions'">
    <!--   
    {{showAll}}
    {{actionTypes |json}} -->
    <amo-form-checkbox 
      label="Select all" 
      appAccessor
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="showAll"
      (ngModelChange)="actionOpts('showAll')"
      [value]="showAll"
      name="showall"
      ngDefaultControl
      [attr.disabled]="readOnly">
    </amo-form-checkbox>

    <hr>
    <!-- user: true, //Trainee Activity Log -->
    <amo-form-checkbox 
      label="Trainee Action" 
      appAccessor
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="actionTypes.user"
      (ngModelChange)="actionOpts('user')"
      [value]="actionTypes.user"
      name="user" 
      ngDefaultControl
      [attr.disabled]="readOnly">
    </amo-form-checkbox>

    <!-- application: true, //Application Activity Log -->
    <amo-form-checkbox 
      label="Application Action" 
      appAccessor
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="actionTypes.application"
      (ngModelChange)="actionOpts('application')"
      [value]="actionTypes.application"
      name="application" 
      ngDefaultControl
      [attr.disabled]="readOnly">
    </amo-form-checkbox>

    <!-- department: true, //Institution Activity Log -->
    <amo-form-checkbox 
      label="Institution Action" 
      appAccessor
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="actionTypes.department"
      (ngModelChange)="actionOpts('department')"
      [value]="actionTypes.department"
      name="department" 
      ngDefaultControl
      [attr.disabled]="readOnly">
    </amo-form-checkbox>

    <!-- program: true, //Program Activity Log -->
    <amo-form-checkbox 
      label="Program Action" 
      appAccessor
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="actionTypes.program"
      (ngModelChange)="actionOpts('program')"
      [value]="actionTypes.program"
      name="program" 
      ngDefaultControl
      [attr.disabled]="readOnly">
    </amo-form-checkbox>

    <!-- payment: true, //Payment activity log -->
    <amo-form-checkbox 
      label="Payment Action" 
      appAccessor
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="actionTypes.payment"
      (ngModelChange)="actionOpts('payment')"
      [value]="actionTypes.payment"
      name="payment" 
      ngDefaultControl
      [attr.disabled]="readOnly">
    </amo-form-checkbox>

    <!-- host: true, //Host Activity Log -->
    <amo-form-checkbox 
      label="Host Action" 
      appAccessor
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="actionTypes.host"
      (ngModelChange)="actionOpts('host')"
      [value]="actionTypes.host"
      name="host" 
      ngDefaultControl
      [attr.disabled]="readOnly">
    </amo-form-checkbox>
  </div>

  <div class="date-actions" *ngIf="open=='dateActions'">
    <!-- {{activeItem}} -->
    <ion-item button lines="none" (click)="dateAction('Most recent')" 
    [ngClass]="{'activeItem' : activeItem=='Most recent'}">
      <ion-label text-wrap>
        <span>Most recent</span>
      </ion-label>
    </ion-item>
    <ion-item button lines="none" (click)="dateAction('Today')" 
    [ngClass]="{'activeItem' : activeItem=='Today'}"
    >
      <ion-label text-wrap>
        <span>Today</span>
      </ion-label>
    </ion-item>
    <ion-item button lines="none" (click)="dateAction('Yesterday')" 
    [ngClass]="{'activeItem' : activeItem=='Yesterday'}"
    >
      <ion-label text-wrap>
        <span>Yesterday</span>
      </ion-label>
    </ion-item>
    <ion-item button lines="none" (click)="dateAction('Last 30 days')" 
    [ngClass]="{'activeItem' : activeItem=='Last 30 days'}"
    >
      <ion-label text-wrap>
        <span>Last 30 days</span>
      </ion-label>
    </ion-item>
    <ion-item button lines="none" 
    (click)="dateAction('Custom range')" 
    [ngClass]="{'activeItem' : activeItem=='Custom range'}"
    disabled
    >
      <ion-label text-wrap>
        <span>Custom range</span>
      </ion-label>
    </ion-item>

  </div>

  <div class="admin-actions" *ngIf="open=='adminActions'">
    <amo-multi-auto-select
      
      [dropdown]="adminUsers"
      (onInputChange)="adminsEvent($event)"
      (onPanelClose)="adminsMenuClosed($event)"
      label=""
      placeholder="Start typing to filter..."
      writableselectmode="false"
      allownull="false"
      [value]="prefAdmin"
      name="prefAdmin"
    ></amo-multi-auto-select>
  </div>

</div>